import { useState } from "react";
import { useDispatch } from "react-redux";

import { signup } from "../../redux/slice/userSlice";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const SignUpForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [name, setName] = useState("");
  const [nameError, setNameError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [cpassword, setCpassword] = useState("");
  const [cpasswordError, setCpasswordError] = useState("");

  const [mobileNumber, setMobileNumber] = useState("");
  const [mobileNumberError, setMobileNumberError] = useState("");
  // const [role, setRole] = useState("CLIENT");

  const handlePasswordVisibility = (e) => {
    setPasswordVisibility((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let err = false;

    const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const mobileRegex = /^9[78]\d{8}$/;
    const nameRegex = /^\w+\s\w+$/;
    if (!name) {
      setNameError("Name is required");
      err = true;
    } else if (!nameRegex.test(name)) {
      setNameError("Enter valid full name");
      err = true;
    }
    if (!email) {
      setEmailError("Email is required");
      err = true;
    } else if (!emailRegex.test(email)) {
      setEmailError("Not a valid email");
      err = true;
    }
    if (!password) {
      setPasswordError("Password is required");
      err = true;
    } else if (password.length < 6) {
      setPasswordError("password should contain atleast 6 letters");
      err = true;
    } else if (password !== cpassword) {
      setPasswordError("Passwords do not match!");
      err = true;
    }
    if (!cpassword) {
      setCpasswordError("Confirm password is required");
      err = true;
    }
    if (!mobileNumber) {
      setMobileNumberError("Mobile number is required");
      err = true;
    } else if (!mobileRegex.test(mobileNumber)) {
      setMobileNumberError("Not a valid mobile number");
      err = true;
    }

    if (!err) {
      const data = { name, email, password, mobileNumber };
      const res = await dispatch(signup(data)).unwrap();
      if (res) {
        navigate("/login", {
          replace: true,
          state: { message: "Please check your email!" },
        });
      }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-3">
          <label htmlFor="name" className="text-textPrimary font-medium ">
            Full Name*
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={name}
            onChange={(e) => {
              setName(e.target.value);
              setNameError("");
            }}
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="Your Name"
            autoFocus
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {nameError}
          </span>
        </div>

        {/* Email input container */}
        <div className="flex flex-col gap-3">
          <label htmlFor="email" className="text-textPrimary font-medium ">
            Email Address*
          </label>
          <input
            type="text"
            id="email"
            name="email"
            value={email}
            onChange={(e) => {
              setEmail(e.target.value);
              setEmailError("");
            }}
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="Your Email  Address"
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {emailError}
          </span>
        </div>

        {/* Password input container */}
        <div className="flex sm:flex-row flex-col gap-3">
          <div className="sm:w-[50%] w-full flex flex-col">
            <label
              htmlFor="password"
              className="text-textPrimary font-medium pb-3"
            >
              Password*
            </label>

            <div className="block">
              <button
                type="button"
                className="absolute mt-4 sm:ml-[170px] ml-[230px] text-[12px]"
                onClick={handlePasswordVisibility}
                tabIndex="-1"
              >
                {passwordVisibility ? (
                  <FaRegEye className="text-[18px]" />
                ) : (
                  <FaRegEyeSlash className="text-[18px]" />
                )}
              </button>
              <input
                type={passwordVisibility ? "text" : "password"}
                id="password"
                name="password"
                className="w-full login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary password-input"
                placeholder="Password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  setPasswordError("");
                }}
              />
            </div>
            <span className="pl-4 text-[12px] italic text-red-500 pt-3">
              {passwordError}
            </span>
          </div>

          {/* confirm password container */}
          <div className="sm:w-[50%] w-full flex flex-col gap-3">
            <label htmlFor="cpassword" className="text-textPrimary font-medium">
              Confirm Password*
            </label>
            <input
              type="password"
              id="cpassword"
              name="cpassword"
              value={cpassword}
              onChange={(e) => {
                setCpassword(e.target.value);
                setPasswordError("");
                setCpasswordError("");
              }}
              className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
              placeholder="Password"
            />
            <span className="pl-4 text-[12px] italic text-red-500">
              {cpasswordError}
            </span>
          </div>
        </div>

        {/* Only mobile number container */}
        <div className="flex flex-col gap-3">
          <label
            htmlFor="mobileNumber"
            className="text-textPrimary font-medium "
          >
            Mobile Number*
          </label>
          <input
            type="text"
            id="mobileNumber"
            name="mobileNumber"
            className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
            placeholder="Your Mobile Number"
            onChange={(e) => {
              setMobileNumber(e.target.value);
              setMobileNumberError("");
            }}
          />
          <span className="pl-4 text-[12px] italic text-red-500">
            {mobileNumberError}
          </span>
        </div>

        {/* Phone number and role container */}
        {/* <div className="flex sm:flex-row flex-col gap-y-3">
          <div className="sm:w-[50%] w-full flex flex-col gap-3 sm:pr-3">
            <label
              htmlFor="mobileNumber"
              className="text-textPrimary font-medium "
            >
              Mobile Number*
            </label>
            <input
              type="text"
              id="mobileNumber"
              name="mobileNumber"
              value={mobileNumber}
              onChange={(e) => setMobileNumber(e.target.value)}
              className="login-input outline outline-[1px] outline-textSecondary/60 focus:outline-textPrimary"
              placeholder="9800000000"
              
            />
          </div>
          <div className="sm:w-[50%] w-full flex flex-col gap-3">
            <label htmlFor="role" className="text-textPrimary font-medium ">
              Role
            </label>
            <div className="flex justify-center items-center login-input">
              <select
                name="role"
                id="role"
                value={role}
                onChange={(e) => setRole(e.target.value)}
                className="bg-white w-full focus:outline-none "
              >
                <option value="CLIENT">User</option>
                <option value="EDITOR">Editor</option>
                <option value="ADMIN">Admin</option>
              </select>
            </div>
          </div>
        </div> */}

        {/* Original with google login */}
        <div className="flex text-center flex-col mt-4 gap-6">
          <button
            type="submit"
            className="h-[52px] bg-secondary rounded-md text-primary text-xl font-medium"
          >
            Register
          </button>
          {/* <span>Or</span>
          <Link className="flex justify-center gap-4 items-center google-container">
            <img src={google} alt="google logo" className="h-[24px] w-[24px]" />
            <span className="self-center font-medium text-xl">
              Login with Google
            </span>
          </Link> */}
        </div>
      </div>
    </form>
  );
};

export default SignUpForm;
